import { LaboratoryDropdown, StandaloneEquipmentDropdownField } from 'Components/List';
import { FormatTypes } from 'Lib/Format';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../Core';
import { ListFieldSection, PageSection } from '../../Layout';
import StandardisationQueryInjectedPropsProvider from './Core/ProviderProps/QueryPropsProvider/StandardisationQueryInjectedPropsProvider';
import StandardizationRecordSection from './StandardizationRecordSection';

const GaugeStandardisationBulkEntry = () => {
  const ready = useSelector((s) => s.gaugeStandardisation.status.ready);
  const homeLaboratoryId = useSelector((state) => state.user.data.HomeLaboratory.Id);
  const laboratoryId = useSelector((state) => state.gaugeStandardisation.query?.LaboratoryId);
  return (
    <>
      <PageSection>
        <StandardisationQueryInjectedPropsProvider>
          <ListFieldSection>
            <Field
              label="Laboratory"
              input={<LaboratoryDropdown />}
              simpleValue
              isClearable={false}
              autoSelectSingleOption
              searchImmediately
              autoSelectedValue={homeLaboratoryId}
              name="LaboratoryId"
            />
            <StandaloneEquipmentDropdownField
              label="Nuclear Gauge"
              equipmentType="nuclear-density-gauge"
              laboratoryId={laboratoryId}
              disabled={!laboratoryId}
              name="SelectedGauge"
            />
            <Field
              input={<TextOutput />}
              label="Today's Date"
              value={moment().format('YYYY-MM-DD')}
              format={{ type: FormatTypes.Date }}
            />
          </ListFieldSection>
        </StandardisationQueryInjectedPropsProvider>
        {ready && <StandardizationRecordSection />}
      </PageSection>
    </>
  );
};

export default GaugeStandardisationBulkEntry;
export { GaugeStandardisationBulkEntry };
